import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getAllLicenseVerifications(_obj, params) {
    const res = await axios.get(`api/license-verifications/`, { params });
    return res.data;
  },

  async getLicenseVerification(_obj, id) {
    const res = await axios.get(`api/license-verifications/${id}/`);
    return res.data;
  },

  async createLicenseVerification(_obj, data) {
    const res = await axios.post(`api/license-verifications/`, data);
    return res.data;
  },

  async updateLicenseVerification(_obj, { id, data }) {
    return axios.patch(`api/license-verifications/${id}/`, data);
  },

  async deleteLicenseVerification(_obj, id) {
    return axios.delete(`api/license-verifications/${id}/`);
  },

  // ----- Proof documents -----
  async createLicenseDocument(_obj, data) {
    const res = await axios.post(`api/license-verifications/documents/`, data);
    return res.data;
  },

  async deleteLicenseDocument(_obj, id) {
    return axios.delete(`api/license-verifications/documents/${id}/`);
  },

  async getLicenseDocUploadPresignedUrl(_obj, data) {
    return (await axios.post(`api/license-verifications/documents/upload-url/`, data)).data.data;
  },

  // Manual verification by an organization: { status, note }.
  async reviewLicenseVerification(_obj, { id, data }) {
    const res = await axios.post(`api/license-verifications/${id}/review/`, data);
    return res.data;
  },
};

export const licenseVerification = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
